<div class="tw-flex tw-flex-col tw-gap-5 tw-py-4 tw-px-6 md:tw-px-12 tw-text-main-text">
  <div class="tw-flex tw-flex-col tw-gap-1">
    <span class="tw-text-[22px] tw-font-medium">{{ 'core-lib.dialog.confirmation.exclude_title' | translate }}</span>
    <span class="tw-text-sm tw-text-gray-500">{{ 'core-lib.dialog.confirmation.exclude_subtitle' | translate }}</span>
  </div>

  <div class="tw-flex tw-flex-col tw-gap-3 tw-rounded-lg tw-bg-background-gray tw-p-4">
    <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-3">
      @if (npsCategory) {
        <span
          class="tw-text-white tw-px-3 tw-py-1 tw-rounded-xl tw-text-xs tw-font-semibold"
          [ngClass]="{
            'tw-bg-red-500': npsCategory === 'detractor',
            'tw-bg-passives': npsCategory === 'passive',
            'tw-bg-promoters': npsCategory === 'promoter'
          }"
        >
          {{ 'models.survey.nps' | translate }} {{ npsRating ?? '-' }} · {{ 'answer_survey.' + npsCategory | translate }}
        </span>
      }
      <span class="tw-text-sm">
        {{ 'shared.survey.rate' | translate }}:
        <b>{{ score ? (score | number: '1.1' | replaceChar: ',' : '.') : '-' }}</b>
      </span>
      <span class="tw-text-sm">{{ productKey | translate }}</span>
    </div>
    <div class="tw-flex tw-flex-wrap tw-gap-x-6 tw-gap-y-1 tw-text-sm">
      <span>{{ 'commons.date_answer' | translate }}: <b>{{ answeredSurvey?.answered_date | formatDate: currentLanguage }}</b></span>
      <span>{{ 'answer_survey.header_table.guest' | translate }}: <b>{{ guestName || '-' }}</b></span>
    </div>
  </div>

  <p class="tw-text-sm tw-mb-0" [innerHTML]="'core-lib.dialog.confirmation.exclude_impact' | translate: { month: affectedMonth }"></p>

  @if (hasCases) {
    <div class="tw-flex tw-gap-2 tw-rounded-lg tw-bg-amber-50 tw-border tw-border-amber-200 tw-p-3 tw-text-sm tw-text-amber-800">
      <i class="far fa-exclamation-triangle tw-mt-0.5"></i>
      <span>{{ 'core-lib.dialog.confirmation.exclude_cases_warning' | translate: { count: answeredSurvey.cases.length } }}</span>
    </div>
  }

  @if (isContacted) {
    <div class="tw-flex tw-gap-2 tw-rounded-lg tw-bg-amber-50 tw-border tw-border-amber-200 tw-p-3 tw-text-sm tw-text-amber-800">
      <i class="far fa-exclamation-triangle tw-mt-0.5"></i>
      <span>{{ 'core-lib.dialog.confirmation.exclude_contacted_warning' | translate }}</span>
    </div>
  }

  <form [formGroup]="deleteForm" class="tw-flex tw-flex-col tw-gap-3">
    <span class="tw-text-sm tw-font-medium">{{ 'core-lib.dialog.confirmation.exclude_reason_label' | translate }} *</span>
    <div class="tw-flex tw-flex-col tw-gap-2">
      @for (reason of deleteReasonList; track reason.reason_id) {
        <label class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-normal-case tw-cursor-pointer tw-mb-0">
          <input class="tw-h-4 tw-w-4" type="radio" formControlName="reason" [value]="reason.reason_id" />
          <span>{{ reason.reason }}</span>
        </label>
      }
    </div>

    <mh-core-lib-textarea-input
      [placeholder]="'core-lib.dialog.confirmation.exclude_comment_placeholder' | translate"
      [formGroup]="deleteForm"
      [keyControl]="'reasonComment'"
      [rows]="3"
      [inputClass]="'!tw-font-[Rubik] tw-border-gray-400 tw-resize-none'"
    >
    </mh-core-lib-textarea-input>
  </form>

  <div class="tw-flex tw-flex-col tw-gap-1 tw-text-xs tw-text-gray-500">
    <span>{{ 'core-lib.dialog.confirmation.exclude_audit_note' | translate }}</span>
    <span class="tw-font-semibold">{{ 'core-lib.dialog.confirmation.exclude_irreversible' | translate }}</span>
  </div>

  <div class="tw-flex tw-justify-end tw-gap-4 tw-py-2">
    <mh-core-lib-button
      [isSecondary]="true"
      [text]="'commons.cancel' | translate"
      [customClass]="'!tw-shadow-none'"
      [textClass]="'tw-font-[Rubik]'"
      [isDisabled]="sending"
      (clicked)="handleCancel()"
    ></mh-core-lib-button>
    <mh-core-lib-button
      [isPrimary]="true"
      [text]="'core-lib.dialog.confirmation.exclude_button' | translate"
      [isDisabled]="deleteForm.invalid || sending"
      [isDownloading]="sending"
      [customClass]="'!tw-shadow-none !tw-bg-[#FF2020] disabled:!tw-bg-main-disabled'"
      [textClass]="'tw-font-[Rubik]'"
      width="'tw-fit'"
      (clicked)="handleExclude()"
    ></mh-core-lib-button>
  </div>
</div>
